import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Scooter: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m360 180h90s0-30 0-30h-60c-16.57 0-30 13.43-30 30z' />
    <path d='m606.03 540.47-141.27-360.47h-29.77v-30h40c6.17 0 11.71 3.78 13.97 9.53l134.05 342.07c6.05 15.43-1.56 32.83-16.99 38.88z' />
    <path d='m615 630c-57.9 0-105-47.1-105-105s47.1-105 105-105 105 47.1 105 105-47.1 105-105 105zm0-180c-41.36 0-75 33.65-75 75s33.64 75 75 75 75-33.65 75-75-33.64-75-75-75z' />
    <path d='m165 630c-57.9 0-105-47.1-105-105s47.1-105 105-105 105 47.1 105 105-47.1 105-105 105zm0-180c-41.36 0-75 33.65-75 75s33.64 75 75 75 75-33.65 75-75-33.64-75-75-75z' />
    <path d='m420 540h-165v-30h156.72l64.6-102.61c8.83-14.02 27.35-18.23 41.37-9.4s-85 135-85 135c-2.75 4.36-7.54 7.01-12.69 7.01z' />
  </IconBase>
));

Scooter.displayName = 'Scooter';

export default Scooter;
